import { render, staticRenderFns } from "./PaymentReminder.vue?vue&type=template&id=23cec226&scoped=true&"
import script from "./PaymentReminder.vue?vue&type=script&lang=js&"
export * from "./PaymentReminder.vue?vue&type=script&lang=js&"
import style0 from "./PaymentReminder.vue?vue&type=style&index=0&id=23cec226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cec226",
  null
  
)

export default component.exports